var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatisfactionRateKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1214",
    d: "M47.1731 16.1798C48.3792 19.1632 48.9999 22.3608 48.9999 25.5901V28.9999C48.9999 30.1044 48.1045 30.9999 46.9999 30.9999H25L40.5981 6.90161C41.0712 7.3161 41.529 7.74991 41.9705 8.20226C44.1991 10.4857 45.9669 13.1964 47.1731 16.1798Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251101",
    d: "M25 31L13 12.3115",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251102",
    d: "M36.8935 11.823C37.1633 11.7642 37.4297 11.9352 37.4885 12.205L38.4468 16.6018C38.5056 16.8716 38.3346 17.138 38.0647 17.1968C37.7949 17.2556 37.5285 17.0846 37.4697 16.8148L36.6179 12.9065L32.7097 13.7583C32.4399 13.8171 32.1735 13.6461 32.1147 13.3763C32.0559 13.1065 32.2269 12.8401 32.4967 12.7813L36.8935 11.823ZM24.5793 30.7298L36.5793 12.0414L37.4207 12.5817L25.4208 31.2701L24.5793 30.7298Z",
    fill: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1213",
    d: "M48.9999 30.9999H4C2.34315 30.9999 1 29.6567 1 27.9999L1 25.5901C1 22.3608 1.62078 19.1633 2.82689 16.1799C4.033 13.1964 5.80082 10.4857 8.02942 8.20226C10.258 5.91886 12.9038 4.10757 15.8156 2.87181C18.7274 1.63604 21.8482 1 24.9999 1C28.1517 1 31.2725 1.63604 34.1843 2.87181C36.52 3.86308 38.6846 5.22468 40.5999 6.90323",
    stroke: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionRateKpi);
export default __webpack_public_path__ + "static/media/satisfactionRateKPI.82ab348c3b671650012e482d616b08de.svg";
export { ForwardRef as ReactComponent };